import { Controller, useFormContext } from "react-hook-form";
import { InvoiceArrivalDetailsFormValues } from "../../types";
import { View } from "react-native-ui-lib";
import { Label, Text, TextField } from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../../../utilities/i18n";

export interface OrderNumberFormInputProps {
  showLabel?: boolean;
}

export const OrderNumberFormInput = ({
  showLabel = false,
}: OrderNumberFormInputProps) => {
  const { t } = useTranslation("invoice_arrival");
  const { control } = useFormContext<InvoiceArrivalDetailsFormValues>();

  return (
    <View>
      <Label label={t("form.order_number.label")}></Label>
      <Text>{t("form.order_number.description")}</Text>
      <Controller
        name="orderNumber"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            value={value ?? ""}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.order_number.placeholder")}
            filled={false}
          />
        )}
      />
    </View>
  );
};
